var $export   = require('./_export')
  , $parseInt = require('./_parse-int');
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/~/core-js/modules/es6.parse-int.js
// module id = ../../../../core-js/modules/es6.parse-int.js
// module chunks = 0